import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
    state () {
      return {
        language: 'zh-tw',
        isMobile: false,
        login_state: false,
        user_data: null,
      }
    },
    mutations: {
      setLogin(state, is_login){
        state.login_state = is_login
      },
      setMobile(state, is_mobile){
        state.isMobile = is_mobile
      },
      setUserData(state, data){
        state.user_data = data
      }
    }
  })

  export default store